import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  max-width: 1232px;\n  width: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  /* padding-left: 16px; */\n  /* padding-right: 16px; */\n  flex-flow: unset;\n  gap: 72px;\n  justify-content: space-between;\n  @media (max-width: 1200px) {\n    gap: 32px;\n    /* padding: 0 32px; */\n  }\n  @media (max-width: 768px) {\n    /* padding: 0 16px; */\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  width: 67%;\n  @media (max-width: ",
        "px) {\n    width: 100%;\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  width: 32%;\n  max-width: 340px;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  position: sticky;\n  top: ",
        ";\n  transition: top 0.2s ease-out;\n  /* SubNav 숨김: GNB(56px) + 여백(32px) = 88px */\n  /* SubNav 노출: GNB(56px) + SubNav(48px) + 여백(32px) = 136px */\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdBanner } from "@/components/Banner/AdBanner/AdBanner";
import { useScrollVisibility } from "@/hooks/useScrollVisibility";
import PurchaseSection from "@/components/Package/PurchaseSection";
import { useFreeTrialCheck } from "@/components/Product/hooks";
import { useAuthStore } from "@/lib/auth/AuthStore";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import ProductPreviewModal from "@/modules/products/components/ProductPreviewModal";
import { Col, Row } from "antd";
import React, { useEffect } from "react";
import { isBooksProduct } from "src/api/booksProducts";
import { getProductHandoutType } from "src/api/product";
import styled from "styled-components";
import { HANDOUT_BREAK_POINT } from ".";
import useHandoutProductStore from "../../../store/relatedProduct";
import { FixedPurchaseSection } from "./FixedPurchaseSection";
import { HandoutPassSectionModal } from "./HandoutPassSectionModal";
import { HandoutProductDetailContent } from "./HandoutProductDetailContent";
import HandoutProductDetailInfo from "./HandoutProductDetailInfo";
export const HandoutProductDetailView = (param)=>{
    let { product , badgeText  } = param;
    var _product_source;
    const { isLoggedIn , user: { hasUsableFreepass  }  } = useAuthStore();
    const { width , isMobile  } = useWindowDimensions();
    const isTablet = width <= HANDOUT_BREAK_POINT.TABLET;
    const { updateCurrentProduct , setFreeTrialData  } = useHandoutProductStore((state)=>({
            updateCurrentProduct: state.updateCurrentProduct,
            setFreeTrialData: state.setFreeTrialData
        }));
    const handoutType = getProductHandoutType(product);
    const isFreepass = handoutType === "freepass";
    // 무료체험 체크 API 호출
    const { data: freeTrialData , isLoading: isFreeTrialLoading  } = useFreeTrialCheck(String(product.id));
    // SubNav 노출 여부 감지 (스크롤 방향에 따라)
    const isSubNavVisible = useScrollVisibility({
        mode: "direction"
    });
    useEffect(()=>{
        //지금 보고있는 자료 업데이트
        updateCurrentProduct(product);
    }, [
        product
    ]);
    // freeTrialData를 store에 저장 (모달에서 사용)
    useEffect(()=>{
        setFreeTrialData(freeTrialData !== null && freeTrialData !== void 0 ? freeTrialData : null, isFreeTrialLoading);
    }, [
        freeTrialData,
        isFreeTrialLoading,
        setFreeTrialData
    ]);
    return /*#__PURE__*/ _jsxs(ProductDetailViewWrapper, {
        children: [
            /*#__PURE__*/ _jsxs(ProductSectionCol, {
                children: [
                    /*#__PURE__*/ _jsx(HandoutProductDetailInfo, {
                        product: product,
                        isFreepass: isFreepass,
                        badgeText: badgeText,
                        freeTrialData: freeTrialData
                    }),
                    /*#__PURE__*/ _jsx(HandoutProductDetailContent, {
                        product: product
                    })
                ]
            }),
            isTablet ? /*#__PURE__*/ _jsx(FixedPurchaseSection, {
                isFreepass: isFreepass,
                handoutType: handoutType,
                freeTrialData: freeTrialData,
                isFreeTrialLoading: isFreeTrialLoading,
                productId: product.id,
                isLoggedIn: isLoggedIn,
                authorId: product.author_id
            }) : /*#__PURE__*/ _jsx(SideSectionCol, {
                children: /*#__PURE__*/ _jsxs(StickySection, {
                    $isSubNavVisible: isSubNavVisible,
                    children: [
                        /*#__PURE__*/ _jsx(PurchaseSection, {
                            product: product,
                            hasUsableFreepass: hasUsableFreepass,
                            isLoggedIn: isLoggedIn,
                            freeTrialData: freeTrialData,
                            isFreeTrialLoading: isFreeTrialLoading
                        }),
                        /*#__PURE__*/ _jsx(AdBanner, {
                            subject: (_product_source = product.source) === null || _product_source === void 0 ? void 0 : _product_source.subject,
                            position: "solvookPlus",
                            mixpanelPosition: "product detail page cta"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(HandoutPassSectionModal, {}),
            !isBooksProduct(product) && !isMobile && /*#__PURE__*/ _jsx(ProductPreviewModal, {
                product: product
            })
        ]
    });
};
export const ProductDetailViewWrapper = styled(Row).withConfig({
    componentId: "sc-83261dac-0"
})(_templateObject());
export const ProductSectionCol = styled(Col).withConfig({
    componentId: "sc-83261dac-1"
})(_templateObject1(), HANDOUT_BREAK_POINT.TABLET);
export const SideSectionCol = styled(Col).withConfig({
    componentId: "sc-83261dac-2"
})(_templateObject2());
export const StickySection = styled.div.withConfig({
    componentId: "sc-83261dac-3"
})(_templateObject3(), (props)=>props.$isSubNavVisible ? "136px" : "88px");
